import { errorMiddleware } from './errors.meta'
import { MetaReducer } from '@ngrx/store'
import { sessionStorageSyncReducer } from './sessionStorage.meta'
import { lastInteractionMiddleware } from './lastInteraction.meta'
import { loadingMiddleware } from './loading.meta'
import { clearState } from '../root-reducer';

export const metaReducers: MetaReducer<any>[] = [
  sessionStorageSyncReducer,
  lastInteractionMiddleware,
  errorMiddleware,
  loadingMiddleware,
  clearState,
]
